import type { TikTokState } from './TikTok.types';

export const INIT_STATE: TikTokState = {
  adAccountStatuses: {},
  authenticationUrl: '',
  loading: false,
  advertisers: [],
};
